import React from 'react';
import Dropdown from '../dropdown/dropdown';
import countries from 'i18n-iso-countries';
import { useTranslation } from 'react-i18next';
import { classnames } from '../../../../utils/classnames';
import { autocompleteDisabled } from '../../../../utils/utils';

export function getLocaleData(locale) {
    const language_splitted = locale.split('-');
    return {
        lang: language_splitted[0].toLowerCase(),
        country: language_splitted.length === 2 ? language_splitted[1].toUpperCase() : language_splitted[0].toUpperCase()
    };
}

export function getCountriesOptions(localeData, mostSelectedCountries) {
    let objCountries = countries.getNames(localeData.lang, { select: 'official' });
    let optionsCountries = [];
    for (const [key, value] of Object.entries(objCountries)) {
        optionsCountries.push({
            label: key === 'TR' ? 'Türkiye' : value,
            value: key
        });
    }

    const mostWithoutDuplicates = Array.from(new Set(mostSelectedCountries));
    // use most for filter because we want to keep the order
    let mostCountries = mostWithoutDuplicates?.map(country => optionsCountries?.find(option => country === option?.value?.toLowerCase()));
    optionsCountries = optionsCountries.filter(o => !mostWithoutDuplicates.includes(o.value.toLowerCase()));
    optionsCountries.sort((a, b) => {
        if (a.label > b.label) {
            return 1;
        }
        if (a.label < b.label) {
            return -1;
        }
        return 0;
    });

    return [...mostCountries, ...optionsCountries];
}

export default function CountrySelector({
    uniqueKey,
    disabled = false,
    required = false,
    className,
    label = null,
    description = null,
    errors = null,
    onChange = () => {},
    placeholder,
    value = null,
    mostSelectedCountries = [],
    display = true,
    eventCountry = null,
}) {
    const { i18n } = useTranslation();
    const defaultCountries = ['fr', 'es','be','de','ch','gb','nl','it','lu','us','ca'];

    const localeData = React.useMemo(() => getLocaleData(i18n.language), [i18n]);

    const countriesOptions = React.useMemo(() => {
        let mostSelected = [];
        // order of countries in mostSelected (value > event > mostProps > default)
        if (value)
            mostSelected = mostSelected.concat([value.toLowerCase()]);
        if (eventCountry)
            mostSelected = mostSelected.concat([eventCountry.toLowerCase()]);
        if (mostSelectedCountries.length)
            mostSelected = mostSelected.concat(mostSelectedCountries?.map(c => c.toLowerCase()));
        mostSelected = mostSelected.concat(defaultCountries);
        return getCountriesOptions(localeData, mostSelected);
    }, [localeData, mostSelectedCountries, eventCountry, value]);

    if (!display) {
        return null
    }

    return (
        <div className={classnames('neo-country', (required && 'required'))}>
            <Dropdown
                uniqueKey={uniqueKey}
                searchable
                className={`${className}`}
                onClear={() => onChange(null)}
                onChange={onChange}
                options={countriesOptions}
                placeholder={placeholder}
                value={value}
                disabled={disabled}
                errors={errors}
                label={label}
                description={description}
                required={required}
                autoComplete={autocompleteDisabled()}
            />
        </div>
    );
}